'use strict';
module.exports = require('./InputSwitch.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/inputswitch/index.js
// module id = 83
// module chunks = 1